<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>Transactions</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="counterpartyKeywords"
            clearable
            outlined
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search by counterparty"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <date-range-picker @onDates="onDatesSelected"/>
        </v-col>
      </v-row>
      <v-col cols="12" md="6">
        <v-data-iterator
          :items="transactions"
          :items-per-page.sync="itemsPerPage"
          :page="page"
          hide-default-footer
        >
          <template v-slot:no-data>
            <h6>No transactions.</h6>
          </template>
          <template v-slot:default="props">
            <v-card
              v-for="transaction in props.items" :key="transaction.uuid"
              outlined
              @click="onTransactionSelect(transaction)"
              >
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-swap-horizontal</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-subtitle>{{transaction.date | formatDate}}</v-list-item-subtitle>
                  <v-list-item-title v-text="counterparty(transaction)"></v-list-item-title>
                  <v-list-item-subtitle v-text="description(transaction)"></v-list-item-subtitle>
                </v-list-item-content>

                <v-spacer />

                <v-list-item-content class="text-right">
                  <p><span class="text-h5">{{transactionAmount(transaction)}}</span><span class="ml-1 font-weight-bold">{{transactionCurrency(transaction)}}</span></p>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </template>
          <template v-slot:footer>
            <v-row class="mt-2 d-md-flex d-sm-flex" align="center" justify="center" v-if="transactions.length > 0">
              <span class="grey--text">Items per page</span>
              <v-menu offset-y class="">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark text color="primary" class="ml-2" v-bind="attrs" v-on="on" >
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <span class="mr-4 grey--text ml-auto">
                Page {{ page }} of {{ numberOfPages }}
              </span>
              <v-btn-toggle rounded>
                <v-btn
                  fab
                  small
                  color="primary"
                  class="mr-1"
                  @click="formerPage"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  fab
                  small
                  color="primary"
                  class="ml-1"
                  @click="nextPage"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-row>
          </template>
        </v-data-iterator>


      </v-col>
        <v-scroll-y-transition mode="out-in">
          <v-col cols="12" md="6" v-if="selectedTransaction" :key="selectedTransaction ? selectedTransaction.uuid : '1'" >
            <v-card outlined>
              <v-card-title class="d-flex flex-row">
                <span>{{counterparty(selectedTransaction)}}</span>
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small text v-bind="attrs" v-on="on" class="ml-auto">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list flat>
                    <v-list-item @click="onTransactionEdit(selectedTransaction)">
                      <v-icon class="mr-2">mdi-pencil</v-icon>
                      <v-list-item-content>Edit</v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="onTransactionDelete(selectedTransaction)">
                      <v-icon class="mr-2">mdi-delete</v-icon>
                      <v-list-item-content>Delete</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>   
              </v-card-title>
              <v-card-subtitle>{{transactionType(selectedTransaction)}}</v-card-subtitle>
              <v-card-text>
                <v-icon>mdi-calendar</v-icon>{{ selectedTransaction.date | formatDate}}
              </v-card-text>
              <v-card-text>{{description(selectedTransaction)}}</v-card-text>
              <v-card-text>
                <v-row dense no-gutters>
                  <v-col cols="5">
                    <v-card outlined>
                      <v-simple-table dense >
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="entry in debitEntries(selectedTransaction)" :key="entry.uuid">
                            <td class="text-caption">
                               <v-tooltip top> 
                                  <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">{{ entry.account | formatAccount }}</span>
                                </template>
                                <span>{{ entry.account.obj().fname }}</span>
                               </v-tooltip>
                            </td>
                            <td class="text-caption" align="right">{{ entry.amount | formatAmount }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    </v-card>

                  </v-col>
                  <v-col class="d-flex justify-center">
                    <v-icon>mdi-arrow-right-thick</v-icon>
                  </v-col>
                  <v-col cols="5">
                    <v-card outlined>
                    <v-simple-table dense >
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="entry in creditEntries(selectedTransaction)" :key="entry.uuid">
                            <td class="text-caption">
                               <v-tooltip top> 
                                  <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">{{ entry.account | formatAccount }}</span>
                                </template>
                                <span>{{ entry.account.obj().fname }}</span>
                               </v-tooltip>
                            </td>
                            <td class="text-caption" align="right">{{ entry.amount | formatAmount }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="selectedTransaction.attachments.length > 0">
                  <v-col cols="12">
                    <div class="text-h6">Attachements</div>
                  </v-col>
                  <v-col cols="4" class="d-flex justify-start"
                    v-for="(attachment, i) in selectedTransaction.attachments" :key="i">
                      <v-card min-height="30px" min-width="150px" color="#385F73">
                        <v-card-text class="white--text" @click="onAttachmentPreview(attachment)">
                          {{attachment.obj().name | truncate15}}
                        </v-card-text>
                      </v-card>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>      
        </v-scroll-y-transition>
    </v-row>
    <transaction-form :show.sync="showEditForm" :transaction.sync="transactionToEdit"/>
    <confirmation-dialog 
      alertType="error"
      dialogType="confirm"
      title="Confirmation"
      :select="confirmDialog.select"
      :message="confirmDialog.message"
      :show.sync="confirmDialog.show"
      :object="confirmDialog.object"
      @onOk="confirmDialog.onOk"
      @onCancel="confirmDialog.onCancel"/>
    <FileViewer :file.sync="fileToPreview" />
  </v-container>
</template>

<script>
import TransactionForm from "@/components/TransactionForm.vue";
import DateRangePicker from '@/components/common/DateRangePicker.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import FileViewer from '@/components/common/FileViewer.vue';

export default {
  name: "TransactionListing",
  components: {
    TransactionForm,
    DateRangePicker,
    ConfirmationDialog,
    FileViewer,
  },
  async created() {
    await this.$store.dispatch("getTransactions");
  },
  data: () => ({
    itemsPerPageArray: [8, 16, 24],
    page: 1,
    itemsPerPage: 8,

    counterpartyKeywords: "",
    selectedDates:[],

    selectedTransaction: undefined,
    showEditForm: false,
    transactionToEdit : undefined,
    confirmDialog: {show: false, message: "", select: {}, onOk: () => {}, onCancel: () => {}},
    fileToPreview: undefined,
  }),
  computed: {
    transactions() {
      return (
        this.$store.getters["getTransactions"](this.counterpartyKeywords, this.selectedDates) || []
      );
    },
    numberOfPages() {
      return Math.ceil(this.transactions.length / this.itemsPerPage);
    },    
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) 
        this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) 
        this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    onDatesSelected(dates) {
      this.selectedDates = dates.map(d => new Date(d));
    },    
    counterparty(transaction) {
      return transaction.counterparty.obj().name || "_";
    },
    description(transaction) {
      return transaction.description || "_";
    },
    transactionType(transaction) {
      return transaction.transactionType ? transaction.transactionType.obj().name : "_"
    },
    transactionAmount(transaction) {
      const amount = this.creditEntries(transaction).map(ent => ent.amount.value).reduce((a,b) => a + b, 0);
      return this.$options.filters.formatDecimal(amount);
    },
    transactionCurrency(transaction) {
      const currencies = transaction.entries.map(ent => ent.amount.currency);
      const firstCurrency = currencies[0];
      const otherCurrencies = currencies.filter(cur => cur.uuid !== firstCurrency.uuid);
      if (otherCurrencies.length == 0) {
        return firstCurrency.obj().symbol;
      }
      return ""
    },
    debitEntries(transaction) {
      return transaction.entries.filter(ent => ent.amount.value < 0);
    },
    creditEntries(transaction) {
      return transaction.entries.filter(ent => ent.amount.value > 0);
    },
    entryAccount(entry) {
      return entry.account.obj().name;
    },
    onTransactionSelect(transaction) {
      this.selectedTransaction = transaction
    },
    onTransactionEdit(transaction) {
      this.transactionToEdit = transaction;
      this.showEditForm = true;
    },
    onTransactionDelete(transaction) {
      this.showDeleteConfirm(transaction)
    },
    showDeleteConfirm(transaction) {
      this.confirmDialog = {show: true, object: transaction, message: "Confirm delete?", select: {}, onOk: this.onDeleteConfirm, onCancel: () => {}}
    },
    async onDeleteConfirm(ret) {
      await this.$store.dispatch("deleteTransaction", ret.object);
      this.$root.$emit("Notification", "Deleted!");
    },
    async onAttachmentPreview(attachment) {
      if (!attachment) {
        return;
      }
      this.fileToPreview = await attachment.obj().getFile();
    }
  },
  watch: {
    transactionToEdit() {
      this.selectedTransaction = this.transactionToEdit;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>